import { IRoute } from "shared/interface/types";
import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";

const parentBreadCrumbs = [{ title: "menu_sidebar_management" }, { title: "menu_sidebar_management_tax_and_admin" }];

const TaxationListing = Loadable({
  loader: () => import("container/management/taxation"),
  loading() {
    return <Loader />;
  }
});

const PaymentMethod = Loadable({
  loader: () => import("container/management/paymentMethod"),
  loading() {
    return <Loader />;
  }
});

const PaymentGateWay = Loadable({
  loader: () => import("container/management/paymentGateway"),
  loading() {
    return <Loader />;
  }
});

const TransactionCost = Loadable({
  loader: () => import("container/management/transactionCost"),
  loading() {
    return <Loader />;
  }
});

const AdminListing = Loadable({
  loader: () => import("container/management/admin"),
  loading() {
    return <Loader />;
  }
});

export const taxAndAdminRoutes: IRoute[] = [
  {
    path: "/management/taxation",
    element: <TaxationListing />,
    handle: {
      crumbs: [...parentBreadCrumbs, { title: "menu_sidebar_management_tax_and_admin_taxation" }]
    }
  },
  {
    path: "/management/payment-method",
    element: <PaymentMethod />,
    handle: {
      crumbs: [...parentBreadCrumbs, { title: "menu_sidebar_management_tax_and_admin_payment_method" }]
    }
  },
  {
    path: "/management/payment-gateway",
    element: <PaymentGateWay />,
    handle: {
      crumbs: [...parentBreadCrumbs, { title: "menu_sidebar_management_tax_and_admin_payment_gateway" }]
    }
  },
  {
    path: "/management/transaction-cost",
    element: <TransactionCost />,
    handle: {
      crumbs: [...parentBreadCrumbs, { title: "menu_sidebar_management_tax_and_admin_transaction_cost" }]
    }
  },
  {
    path: "/management/admin",
    element: <AdminListing />,
    handle: {
      crumbs: [...parentBreadCrumbs, { title: "menu_sidebar_management_tax_and_admin_admin" }]
    }
  }
];
